// Pure text helpers shared by the React app and the meta sidecar (meta-service/).
// Keep this file free of React, browser and process.env access.

export function stripHtmlTags(str?: string | null): string {
  if (!str) return '';
  return str
    // First decode HTML entities so escaped tags like &lt;p&gt; become <p>
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    // Second, strip all HTML tags (including <p>, </p>, <a>, etc.)
    .replace(/<[^>]*>/g, '')
    // Extra safety: remove any leftover literal p tag fragments
    .replace(/<\/?p[^>]*>/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export const truncate = (str: string, max: number): string =>
  str.length > max ? `${str.slice(0, max)}...` : str;
